var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "dialog-idea-settings" } },
    [
      _c(
        "ib-dialog",
        {
          staticClass: "dialog-idea-settings",
          attrs: {
            fullscreen: "",
            visible: _vm.visible,
            "show-close": false,
            width: "960px",
            top: "5vh",
          },
          on: {
            open: _vm.onDialogOpen,
            close: _vm.closeDialog,
            closed: _vm.onDialogClosed,
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  !_vm.updateSettings && _vm.firstTime
                    ? _c("stepper-pagination", {
                        staticClass: "text-uppercase mb-2 mb-md-4",
                        attrs: {
                          "additional-text": _vm.$t("pages.ideaSettings.title"),
                          color: "blue",
                          "number-of-steps": 4,
                          "active-step": 4,
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex px-5 position-relative align-items-center",
                        },
                        [
                          _c("h1", { staticClass: "m-0" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("pages.ideaSettings.title")) +
                                " "
                            ),
                          ]),
                          _vm.loadingOnOpenDialog
                            ? _c("i", { staticClass: "el-icon-loading h2" })
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                  _c("p", { staticClass: "text-lead m-0" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("pages.ideaSettings.subtitle")) + " "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _c("ib-dialog-container", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-items-center justify-content-end idea-settings-footer pt-3",
                      },
                      [
                        _c("ib-dialog-footer", {
                          attrs: {
                            "button-size": "md",
                            "submit-btn-text": _vm.updateSettings
                              ? _vm.$t("applyChanges")
                              : _vm.$t("letsStart"),
                            "cancel-btn-text": _vm.updateSettings
                              ? _vm.$t("cancel")
                              : _vm.$t("chooseSomethingElse"),
                            "submit-btn-class": !_vm.updateSettings
                              ? "gtm_onboarding-button-start"
                              : null,
                            loading: _vm.loadingOnSaveIdea,
                            "disable-submit-btn": _vm.loadingOnOpenDialog,
                          },
                          on: {
                            submit: function ($event) {
                              _vm.updateSettings
                                ? _vm.onEditIdea()
                                : _vm.onSaveIdea()
                            },
                            cancel: function ($event) {
                              return _vm.$router.go(-1)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("ib-dialog-container", { staticClass: "py-2" }, [
            _c("div", { staticClass: "dialog-body" }, [
              _c(
                "div",
                { staticClass: "idea-settings-card" },
                [
                  _c(
                    "v-app",
                    [
                      _c(
                        "v-row",
                        { attrs: { gutter: 10 } },
                        [
                          _c("v-col", { attrs: { cols: 12, md: 5 } }, [
                            _c(
                              "div",
                              { staticClass: "illustration-wrapper m-auto" },
                              [
                                !_vm.startFromScratch
                                  ? [
                                      _vm.form.image === null &&
                                      _vm.form.croppedImage === null &&
                                      _vm.form.uploadedImage === null &&
                                      _vm.idea.icon
                                        ? _c("div", {
                                            staticClass: "icon-wrapper",
                                            style: {
                                              backgroundImage:
                                                _vm.imageUrl(_vm.idea.icon) ||
                                                _vm.imageUrl(_vm.category.icon),
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                                _c(
                                  "div",
                                  { staticClass: "idea-image-uploader" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.form.image !== null ||
                                              _vm.form.croppedImage !== null,
                                            expression:
                                              "form.image !== null || form.croppedImage !== null",
                                          },
                                        ],
                                        staticClass: "avatar-container",
                                        class: {
                                          disable: _vm.loadingOnOpenDialog,
                                        },
                                        style: _vm.cardImage(
                                          _vm.form.image
                                            ? _vm.form.image.path +
                                                _vm.form.image.filename
                                            : _vm.form.croppedImage
                                        ),
                                        on: { click: _vm.deleteImage },
                                      },
                                      [
                                        _c("span", [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg",
                                                width: "20",
                                                height: "22",
                                                viewBox: "0 0 20 22",
                                                "svg-inline": "",
                                                role: "presentation",
                                                focusable: "false",
                                                tabindex: "-1",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  "fill-rule": "evenodd",
                                                  d: "M15 4h4a1 1 0 110 2h-1v13a3 3 0 01-3 3H5a3 3 0 01-3-3V6H1a1 1 0 110-2h4V3a3 3 0 013-3h4a3 3 0 013 3v1zm-2 0V3a1 1 0 00-1-1H8a1 1 0 00-1 1v1h6zm3 2H4v13a1 1 0 001 1h10a1 1 0 001-1V6zm-9 4a1 1 0 112 0v6a1 1 0 11-2 0v-6zm4 0a1 1 0 112 0v6a1 1 0 11-2 0v-6z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !(
                                              _vm.form.image !== null ||
                                              _vm.form.croppedImage !== null
                                            ),
                                            expression:
                                              "!(form.image !== null || form.croppedImage !== null)",
                                          },
                                        ],
                                      },
                                      [
                                        _c(
                                          "ib-tooltip",
                                          {
                                            attrs: {
                                              placement: "top-end",
                                              "popper-class": "medium center",
                                              content: _vm.$t(
                                                "uploadOwnPictureOrLogo"
                                              ),
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      !_vm.form.uploadedImage,
                                                    expression:
                                                      "!form.uploadedImage",
                                                  },
                                                ],
                                                staticClass: "plus",
                                                class: {
                                                  disable:
                                                    _vm.loadingOnOpenDialog,
                                                },
                                                on: {
                                                  click: _vm.openImageUploader,
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-plus avatar-uploader-icon",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.form.uploadedImage === null
                                          ? _c(
                                              "label",
                                              {
                                                staticClass: "upload-label",
                                                staticStyle: {
                                                  "background-size": "contain",
                                                },
                                                style: {
                                                  backgroundImage:
                                                    _vm.imageUrl(
                                                      _vm.idea.cover
                                                    ) ||
                                                    _vm.imageUrl(
                                                      _vm.category.cover
                                                    ),
                                                },
                                                attrs: { for: "upload-img" },
                                              },
                                              [
                                                _c("input", {
                                                  ref: "imageUploader",
                                                  staticClass:
                                                    "avatar-uploader-icon",
                                                  class: {
                                                    disable:
                                                      _vm.loadingOnOpenDialog,
                                                  },
                                                  attrs: {
                                                    id: "upload-img",
                                                    disabled:
                                                      _vm.loadingOnOpenDialog,
                                                    type: "file",
                                                    accept: "image/*",
                                                  },
                                                  on: { change: _vm.setImage },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c("vue-cropper", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.form.uploadedImage,
                                              expression: "form.uploadedImage",
                                            },
                                          ],
                                          ref: "cropper",
                                          staticClass: "cropper",
                                          class: {
                                            unhidden: _vm.form.uploadedImage,
                                          },
                                          attrs: {
                                            guides: true,
                                            "view-mode": 0,
                                            "drag-mode": "crop",
                                            "auto-crop-area": 1,
                                            "min-container-width": 335,
                                            "min-container-height": 335,
                                            background: true,
                                            "output-type": "png",
                                            src: _vm.form.uploadedImage,
                                            alt: "",
                                            "img-style": {
                                              width: "335px",
                                              height: "335px",
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              2
                            ),
                            _c(
                              "h2",
                              { staticClass: "text-center text-md-left h4" },
                              [_vm._v(" " + _vm._s(_vm.form.name) + " ")]
                            ),
                            _vm.updateIdeaSettings
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "o-50 m-0 text-center text-md-left",
                                  },
                                  [_vm._v(" " + _vm._s(_vm.idea.name) + " ")]
                                )
                              : _vm._e(),
                          ]),
                          _c(
                            "v-col",
                            {
                              staticClass: "form-fields-wrapper",
                              attrs: { cols: 12, md: 7 },
                            },
                            [
                              _c(
                                "v-form",
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "mb-1",
                                          attrs: { cols: 12 },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: `${_vm.$t(
                                                "pages.ideaSettings.ideaName"
                                              )} *`,
                                              disabled: _vm.loadingOnOpenDialog,
                                              error:
                                                _vm.showValidationErrors &&
                                                !_vm.form.name,
                                              outlined: "",
                                              color: "blue",
                                              maxlength: "50",
                                              "hide-details": true,
                                              dense: "",
                                              "background-color": "#FAFBFF",
                                              height: "52px",
                                            },
                                            on: { blur: _vm.onIdeaNameBlur },
                                            nativeOn: {
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                _vm.updateSettings
                                                  ? _vm.onEditIdea()
                                                  : _vm.onSaveIdea()
                                              },
                                            },
                                            model: {
                                              value: _vm.form.name,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "name", $$v)
                                              },
                                              expression: "form.name",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "my-1",
                                          attrs: { cols: 12 },
                                        },
                                        [
                                          _c("v-textarea", {
                                            attrs: {
                                              disabled: _vm.loadingOnOpenDialog,
                                              color: "blue",
                                              rows: 2,
                                              label: `${_vm.$t(
                                                "pages.ideaSettings.ideaDescription"
                                              )}`,
                                              outlined: "",
                                              "hide-details": true,
                                              "background-color": "#FAFBFF",
                                              maxlength: "500",
                                            },
                                            model: {
                                              value: _vm.form.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression: "form.description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "my-1",
                                          attrs: { cols: 12, md: 6 },
                                        },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              label: `${_vm.$t(
                                                "pages.ideaSettings.ideaCountry"
                                              )}`,
                                              items: _vm.countries,
                                              outlined: "",
                                              disabled: _vm.loadingOnOpenDialog,
                                              "hide-details": true,
                                              "item-value": "code",
                                              "item-text": "name",
                                              clearable: "",
                                              color: "blue",
                                              "item-color": "blue",
                                              dense: "",
                                              "background-color": "#FAFBFF",
                                              height: "52px",
                                            },
                                            model: {
                                              value: _vm.form.country,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "country",
                                                  $$v
                                                )
                                              },
                                              expression: "form.country",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "my-1",
                                          attrs: { cols: 12, md: 6 },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: _vm.$t(
                                                "pages.ideaSettings.ideaCity"
                                              ),
                                              disabled: _vm.loadingOnOpenDialog,
                                              outlined: "",
                                              maxlength: "50",
                                              "hide-details": true,
                                              dense: "",
                                              color: "blue",
                                              "background-color": "#FAFBFF",
                                              height: "52px",
                                            },
                                            on: { blur: _vm.onIdeaNameBlur },
                                            nativeOn: {
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                _vm.updateSettings
                                                  ? _vm.onEditIdea()
                                                  : _vm.onSaveIdea()
                                              },
                                            },
                                            model: {
                                              value: _vm.form.city,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "city", $$v)
                                              },
                                              expression: "form.city",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "my-1",
                                          attrs: { cols: 12 },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: `${_vm.$t(
                                                "pages.ideaSettings.ideaStage"
                                              )} *`,
                                              items: _vm.stages,
                                              outlined: "",
                                              color: "blue",
                                              "item-color": "blue",
                                              error:
                                                _vm.showValidationErrors &&
                                                !_vm.form.stage,
                                              disabled: _vm.loadingOnOpenDialog,
                                              "hide-details": true,
                                              "item-value": "type",
                                              "item-text": (item) =>
                                                _vm.$t(item.title),
                                              dense: "",
                                              "background-color": "#FAFBFF",
                                              "menu-props": { offsetY: true },
                                              height: "52px",
                                            },
                                            model: {
                                              value: _vm.form.stage,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "stage", $$v)
                                              },
                                              expression: "form.stage",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "my-1",
                                          attrs: { cols: 12 },
                                        },
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              label: `${_vm.$t(
                                                "pages.ideaSettings.ideaType"
                                              )} *`,
                                              items:
                                                _vm.catalogueOptionsFormatted,
                                              outlined: "",
                                              color: "blue",
                                              "item-color": "blue",
                                              error:
                                                _vm.showValidationErrors &&
                                                !_vm.catalogueIdeaId,
                                              disabled: _vm.loadingOnOpenDialog,
                                              "hide-details": true,
                                              "item-value": "id",
                                              "item-text": (item) =>
                                                item.options
                                                  ? item.options[
                                                      _vm.currentLang
                                                    ].name
                                                  : item.name,
                                              dense: "",
                                              "background-color": "#FAFBFF",
                                              height: "52px",
                                            },
                                            model: {
                                              value: _vm.catalogueIdeaId,
                                              callback: function ($$v) {
                                                _vm.catalogueIdeaId = $$v
                                              },
                                              expression: "catalogueIdeaId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "my-1",
                                          attrs: { cols: 12 },
                                        },
                                        [
                                          _c("v-textarea", {
                                            attrs: {
                                              disabled: _vm.loadingOnOpenDialog,
                                              rows: 2,
                                              color: "blue",
                                              placeholder: _vm.$t(
                                                "pages.ideaSettings.addSlogan"
                                              ),
                                              outlined: "",
                                              "hide-details": true,
                                              "background-color": "#FAFBFF",
                                              maxlength: "500",
                                            },
                                            model: {
                                              value: _vm.form.slogan,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "slogan",
                                                  $$v
                                                )
                                              },
                                              expression: "form.slogan",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "pt-0 my-1",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "my-1",
                                          attrs: { cols: 12 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "d-flex mb-1" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-lead my-0 mr-1",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "pages.financialPlan.financialSettings"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("v-autocomplete", {
                                            attrs: {
                                              items: _vm.currencies,
                                              "item-value": "code",
                                              "item-text": "name",
                                              outlined: "",
                                              color: "blue",
                                              "item-color": "blue",
                                              disabled: _vm.loadingOnOpenDialog,
                                              error:
                                                _vm.showValidationErrors &&
                                                !_vm.form.currency,
                                              label: `${_vm.$t(
                                                "pages.financialPlan.settings.currency"
                                              )} *`,
                                              "hide-details": true,
                                              dense: "",
                                              "background-color": "#FAFBFF",
                                              height: "52px",
                                            },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "item",
                                                fn: function ({ item }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "font-size": "13px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name) +
                                                            " (" +
                                                            _vm._s(
                                                              item.symbol
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                              },
                                              {
                                                key: "selection",
                                                fn: function () {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.selectedCurrency
                                                            .name
                                                        ) +
                                                          " (" +
                                                          _vm._s(
                                                            _vm.selectedCurrency
                                                              .symbol
                                                          ) +
                                                          ")"
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ]),
                                            model: {
                                              value: _vm.form.currency,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "currency",
                                                  $$v
                                                )
                                              },
                                              expression: "form.currency",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "my-1",
                                          attrs: { cols: 12, md: 6 },
                                        },
                                        [
                                          _c(
                                            "v-menu",
                                            {
                                              ref: "menu",
                                              attrs: {
                                                "close-on-content-click": false,
                                                "offset-y": "",
                                                "max-width": "243px",
                                                "min-width": "243px",
                                              },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-text-field",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                value:
                                                                  _vm.formatDateForStartingFrom,
                                                                label: `${_vm.$t(
                                                                  "pages.financialPlan.settings.planningStart"
                                                                )} *`,
                                                                readonly: "",
                                                                outlined: "",
                                                                disabled:
                                                                  _vm.loadingOnOpenDialog,
                                                                "hide-details": true,
                                                                "append-icon":
                                                                  _vm.icons
                                                                    .mdiCalendarMonthOutline,
                                                                dense: "",
                                                                color: "blue",
                                                                "background-color":
                                                                  "#FAFBFF",
                                                                height: "52px",
                                                              },
                                                              on: {
                                                                "click:append":
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.dateStartingFromMenuVisible = true
                                                                  },
                                                              },
                                                            },
                                                            "v-text-field",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ]),
                                              model: {
                                                value:
                                                  _vm.dateStartingFromMenuVisible,
                                                callback: function ($$v) {
                                                  _vm.dateStartingFromMenuVisible =
                                                    $$v
                                                },
                                                expression:
                                                  "dateStartingFromMenuVisible",
                                              },
                                            },
                                            [
                                              _c("v-date-picker", {
                                                attrs: {
                                                  width: 243,
                                                  color: "blue",
                                                  type: "month",
                                                  min: _vm.minDate,
                                                  max: _vm.maxDate,
                                                  scrollable: "",
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.dateStartingFromMenuVisible = false
                                                  },
                                                },
                                                model: {
                                                  value: _vm.form.startingFrom,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "startingFrom",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.startingFrom",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "my-1",
                                          attrs: { cols: 12, md: 6 },
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.planningForOptions,
                                              "item-value": "value",
                                              "item-text": "label",
                                              outlined: "",
                                              color: "blue",
                                              "item-color": "blue",
                                              disabled: _vm.loadingOnOpenDialog,
                                              label: `${_vm.$t(
                                                "pages.ideaSettings.planningPeriod"
                                              )} *`,
                                              "menu-props": { offsetY: true },
                                              "hide-details": true,
                                              error:
                                                _vm.showValidationErrors &&
                                                !_vm.form.planningFor,
                                              dense: "",
                                              "background-color": "#FAFBFF",
                                              height: "52px",
                                            },
                                            model: {
                                              value: _vm.form.planningFor,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "planningFor",
                                                  $$v
                                                )
                                              },
                                              expression: "form.planningFor",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }